import { TestIdDomain } from 'constants/testIds';

export const LoanNavigationTabsTestIds = {
  LOAN_MENU: `${TestIdDomain.LOAN}.menu`,
};
